import { wasUpdateAccepted } from './updateSignal';

/**
 * Wires the actual page reload for `UpdateBanner`'s "Actualizar" (fix round
 * 1, review finding): `service-worker.js`'s `clientsClaim()` fires
 * `controllerchange` for every client a new worker takes over, INCLUDING the
 * very first install (no previous controller) or right after someone clears
 * site data — neither of those is a user-requested update, so reloading
 * there would surprise a brand new visitor with an unrequested refresh.
 * `wasAccepted()` (default: `wasUpdateAccepted` from `updateSignal.js`,
 * flipped by `UpdateBanner` right before it posts `SKIP_WAITING`) is the one
 * signal that distinguishes that from an actually accepted update.
 * `container`/`reload` are injected so this is testable without a real
 * `navigator.serviceWorker`/`window.location`.
 */
export function reloadOnAcceptedUpdate(
  container,
  wasAccepted = wasUpdateAccepted,
  reload = () => window.location.reload(),
) {
  if (!container) return () => {};

  let refreshed = false;
  function handleControllerChange() {
    if (refreshed || !wasAccepted()) return;
    refreshed = true;
    reload();
  }

  container.addEventListener('controllerchange', handleControllerChange);
  return () => container.removeEventListener('controllerchange', handleControllerChange);
}
